import React, { useEffect, useState } from 'react';
import { dateToDateString } from '../../etc/etcfunctions';
import { DataGridPremium, GridFilterModel, GridRowModel } from '@mui/x-data-grid-premium';
import { dayNumberToKorean, englishLocationToKorean } from '../../../../../data/locationFuntion';
import { Button } from '@mui/joy';
import { toast } from 'react-toastify';
import { Backdrop, CircularProgress, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { postFetch } from '../../../../../fetch/fetch';

const bookingColumns = [
    { field: "location", headerName: "지점", width: 100, filterable: true },
    { field: "date", headerName: "예약일", width: 150 },
    { field: "time", headerName: "예약시간", width: 150 },
    { field: "name", headerName: "이름", width: 100 },
    { field: "phone", headerName: "전화번호", width: 150 },
    { field: "memo", headerName: "메모", width: 200, editable: true },
    { field: "createdAt", headerName: "신청시간", width: 180 }
];

const PhoneConsult: React.FC<any> = (props) => {

    const [phoneRows, setPhoneRows] = useState<any[]>([]);
    const [selectedRowId, setSelectedRowId] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const [alignment, setAlignment] = useState('total');
    const [alignment2, setAlignment2] = useState('current');
    const [filterModel, setFilterModel] = useState<GridFilterModel>({
        items: [{ id: 2, field: 'location', operator: 'contains', value: "" }],
    });

    const getBookedList = async () => {
        try {
            const result: any = await postFetch("/dashboard/report/bookingTotalData", {});
            const data = result.data;

            var newRows: any = [];

            data.forEach((each: any) => {
                if (each.kind !== 1) return;

                const oneRow: any = {};
                oneRow.id = each.id;
                oneRow.location = englishLocationToKorean(each.location);

                const date = new Date(each.date);
                oneRow.date = dateToDateString(date) + ` (${dayNumberToKorean(date.getDay())})`;

                var ampm = "오전";
                var hours = Math.floor(each.time / 60);
                var minutes = each.time % 60;
                const realDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), hours, minutes);
                oneRow.dateData = realDate;

                if (hours >= 12) {
                    ampm = "오후";
                    if (hours > 12) hours -= 12;
                }
                oneRow.time = `${ampm} ${hours}시` + (minutes > 0 ? ` ${minutes}분` : '');
                oneRow.name = each.name;
                oneRow.memo = each.memo;
                oneRow.phone = each.telephoneNumber;
                oneRow.timeNumber = realDate.getTime();

                newRows.push(oneRow);
            });

            const current = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());

            if (alignment2 === "current") {
                newRows = newRows.filter((r: any) => r.dateData.getTime() >= current.getTime());
            } else {
                newRows = newRows.filter((r: any) => r.dateData.getTime() < current.getTime());
            }

            newRows.sort((a: any, b: any) =>
                alignment2 === "current" ? a.timeNumber - b.timeNumber : b.timeNumber - a.timeNumber
            );

            setPhoneRows(newRows);
        } catch (e) {}
    };

    useEffect(() => {
        getBookedList();
    }, [alignment2]);

    const deleteRow = async () => {
        if (!selectedRowId) return;
        if (!window.confirm("정말 삭제하시겠습니까?")) return;
        setLoading(true);
        try {
            const response = await fetch("https://suneungsunbae.com/api/booking/parkgaeul", {
                method: "delete",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ selectionModel: [selectedRowId] })
            });
            const result = await response.json();
            if (result.message === "success") {
                toast.success("삭제 성공!", { position: "bottom-right", autoClose: 3000, hideProgressBar: true, theme: "colored" });
                getBookedList();
                setSelectedRowId(null);
            }
        } catch (e) {
            toast.error("전송 실패!", { position: "bottom-right", autoClose: 3000, hideProgressBar: true, theme: "colored" });
        }
        setLoading(false);
    };

    const handleEditCommit = React.useCallback(
        async (newRow: GridRowModel, old: any) => {
            var field = "";
            for (const [key, value] of Object.entries(newRow)) {
                if (value !== old[key]) field = key;
            }
            const value = newRow[field] ? newRow[field] : null;
            const id = newRow.id;
            if (!field || !id) return newRow;
            try {
                fetch("https://suneungsunbae.com/api/booking/memo", {
                    method: "post",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ value, id, field })
                }).then(r => r.json()).then(() => getBookedList());
            } catch (e) {}
            return newRow;
        }, [alignment2]
    );

    const handleProcessRowUpdateError = React.useCallback((error: Error) => {
        alert(error.message);
    }, []);

    const handleAlignmentChange = (event: React.MouseEvent<HTMLElement>, newAlignment: string) => {
        if (!newAlignment) return;
        setAlignment(newAlignment);
        const newFilterModel = { ...filterModel };
        newFilterModel.items[0] = {
            ...newFilterModel.items[0],
            value: newAlignment === "total" ? "" : newAlignment
        };
        setFilterModel(newFilterModel);
    };

    const handleAlignmentChange2 = (event: React.MouseEvent<HTMLElement>, newAlignment: string) => {
        if (!newAlignment) return;
        setAlignment2(newAlignment);
    };

    return (
        <div style={{ marginBottom: "32px" }}>
            {/* 현재/과거 토글 */}
            <div style={{ marginBottom: "12px" }}>
                <ToggleButtonGroup
                    color="primary"
                    value={alignment2}
                    exclusive
                    onChange={handleAlignmentChange2}
                >
                    <ToggleButton value="current">현재내역</ToggleButton>
                    <ToggleButton value="past">과거내역</ToggleButton>
                </ToggleButtonGroup>
            </div>

            {/* 지점 필터 + 삭제 */}
            <div style={{
                width: "1200px",
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "10px"
            }}>
                <ToggleButtonGroup
                    color="primary"
                    value={alignment}
                    exclusive
                    onChange={handleAlignmentChange}
                >
                    <ToggleButton value="total">전체</ToggleButton>
                    <ToggleButton value="강남점">강남점</ToggleButton>
                    <ToggleButton value="대치점">대치점</ToggleButton>
                    <ToggleButton value="분당점">분당점</ToggleButton>
                    <ToggleButton value="송파점">송파점</ToggleButton>
                    <ToggleButton value="대구점">대구점</ToggleButton>
                    <ToggleButton value="김포점">김포점</ToggleButton>
                    <ToggleButton value="신촌점">신촌점</ToggleButton>
                    <ToggleButton value="강동점">강동점</ToggleButton>
                    <ToggleButton value="하남점">하남점</ToggleButton>
                    <ToggleButton value="센텀점">센텀점</ToggleButton>
                    <ToggleButton value="동탄점">동탄점</ToggleButton>
                </ToggleButtonGroup>
                <Button
                    color='warning'
                    variant='soft'
                    disabled={!selectedRowId}
                    onClick={deleteRow}
                >
                    삭제하기
                </Button>
            </div>

            {/* 전화상담 헤더 */}
            <div style={{ marginBottom: "8px", fontWeight: "bold", fontSize: "15px" }}>전화상담</div>

            <div style={{ backgroundColor: "white", width: "1200px", height: "400px" }}>
                <DataGridPremium
                    rows={phoneRows}
                    columns={bookingColumns}
                    density='compact'
                    onRowClick={(params) => setSelectedRowId(params.row.id)}
                    filterModel={filterModel}
                    onFilterModelChange={(model) => setFilterModel(model)}
                    processRowUpdate={handleEditCommit}
                    onProcessRowUpdateError={handleProcessRowUpdateError}
                />
            </div>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
};

export default PhoneConsult;
